import React, { Component } from "react";
class PaymentCompleted extends Component {
    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header paymentModelHeader">
                        <img src="/images/subscriptionModel.png" alt=""></img>
                    </div>
                    <h2 className="model-title" id="model-title">
                        Payment completed
                    </h2>
                    <div className="model-content">
                        <div className="m-2 text-center">
                            Payment completed you can publish your job listing .
                        </div>
                    </div>

                    <div className="model-actions">
                        <button
                            type="button"
                            onClick={this.props.hidePay}
                            className="btn btn-default"
                        >
                            Close
                        </button>

                        <div className="m-3 text-muted small">
                            You can{" "}
                            <a href="/employer/billing" target="_blank">
                                manage your card
                            </a>{" "}
                            and view your{" "}
                            <a href="/employer/orders" target="_blank">
                                billing history
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default PaymentCompleted;



// WEBPACK FOOTER //
// ./src/components/employer/jobListing/PaymentCompleted.js